import graphql from "babel-plugin-relay/macro";

const CancellationPolicyBasedOnRouteQuery = graphql`
query CancellationPolicyBasedOnRouteQuery(
	$journeyDate: String
	$sourceCityId: Int
	$destinationCityId: Int
	$routeId: Int
	$routeTimeId: Int
	$arrangementId: Int
	$isSameDay: String
){
	cancellationPolicyBasedOnRoute(
		journeyDate: $journeyDate
		sourceCityId: $sourceCityId
		destinationCityId: $destinationCityId
		routeId: $routeId
		routeTimeId: $routeTimeId
		arrangementId: $arrangementId
		isSameDay: $isSameDay
	) {
	    fromMinutes
	    toMinutes
	    deductPercentage
	    refundPercentage
	    createdDate
	    updatedDate
	    remarks
	}
}
	`
export default CancellationPolicyBasedOnRouteQuery;